exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sm-img[data-v-c82bea26]{max-height:16px}", ""]);

// exports
